<template>
    <div class="header_placeholder" :style="`height: ${height}px;`">
        <div class="component-wrap" ref="header">
            <div class="header_bar fx-row" :class="type === 'light' ? 'header--light' : 'header--dark'">
                <div class="header_location fx-middle">
                    <div @click="$goPage('city')">
                        <span>{{currentCityName}}</span>
                        <img :src="require(type === 'light' ? './static/extend_grey.png' : './static/extend.png')" />
                    </div>
                </div>
                <div class="header_search fx-fill fx-middle">
                    <van-search placeholder="搜索影院" background="transparent" @focus="searchFocus"  shape="round">
                        <template #left-icon>
                            <van-icon name="search" color="#909399"></van-icon>
                        </template>
                    </van-search>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        type: {
            type: String,
            default() {
                return "light"
            }
        },
        round: Boolean,
    },
    data() {
        return {
            height: 0,
            query: this.$route.query
        }
    },
    computed: {
        ...mapGetters([
            'currentCityCode',
            'currentCityName'
        ]),
    },
    methods: {
        searchFocus() {
            this.$goPage('search', this.query);
        }
    },
    mounted() {
        this.height = this.$refs.header.clientHeight;
    }
}
</script>

<style lang="scss" scoped>
.component-wrap {
	position: fixed;
	z-index: 10;
	.header_bar.header--dark {
		background-color: #3d4957;
		.header_location {
			color: #fff;
		}
		/deep/ .van-search__content {
			background-color: rgba(255, 255, 255, 0.2) !important;
		}
	}
	.header_bar.header--light {
		background-color: #fff;
		.header_location {
			color: #323232;
		}
		/deep/ input {
			color: #323232 !important;
		}
	}
	.header_bar {
		width: 100%;
		height: 60px;
		padding: 0 15px;
		.header_location {
			font-size: 14px;
			img {
				width: 8px;
				height: 6px;
				margin-left: 5px;
			}
		}
		.header_search {
			.van-search {
				padding-right: 0 !important;
				/deep/ .van-search__content {
					// border-radius: 4px;
				}
				/deep/ input {
					color: #fff;
				}
			}
		}
	}
}
</style>
